import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import Court from '../../entities/booking/court';
import CourtImage from '../../entities/booking/courtImage'

interface CourtState extends ListState<Court>{
    editCourt:Court
}
class CourtMutations extends ListMutations<Court>{

}
class CourtModule extends ListModule<CourtState,any,Court>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Court>(),
        loading:false,
        editCourt:new Court()
    }
    actions={
        async getAll(context:ActionContext<CourtState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Court/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Court>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<CourtState,any>,payload:any){
            await Ajax.post('/api/services/app/Court/Create',payload.data);
        },
        async createWithImages(context:ActionContext<CourtState,any>,payload:any){
            await Ajax.post('/api/services/app/Court/CreateWithImages',payload.data);
        },
        async update(context:ActionContext<CourtState,any>,payload:any){
            await Ajax.put('/api/services/app/Court/Update',payload.data);
        },
        async updateWithImages(context:ActionContext<CourtState,any>,payload:any){
            await Ajax.put('/api/services/app/Court/UpdateWithImages',payload.data);
        },
        async delete(context:ActionContext<CourtState,any>,payload:any){
            context.state.loading=true;
            await Ajax.delete('/api/services/app/Court/Delete?Id='+payload.data.id);
            context.state.loading=false;
        },
        async get(context:ActionContext<CourtState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Court/Get?Id='+payload.id);
            return reponse.data.result as Court;
        }
    };
    mutations={
        setCurrentPage(state:CourtState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CourtState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:CourtState,court:Court){
            state.editCourt=court;
        },
        changeLoading(state:CourtState,pass:boolean){
            state.loading = pass;
        }
    }
}
const courtModule=new CourtModule();
export default courtModule;